module.exports = __webpack_public_path__ + "img/kenya-rec.cf1aa139.svg";